const _storage = {};
export default {
  hasLocalStorage() {
    return ('localStorage' in window) &&
        localStorage !== null;
  },
  getItem(key) {
    let obj = '';
    if (this.hasLocalStorage()) {
      const value = localStorage.getItem(key);
      try {
        obj = JSON.parse(value);
      } catch (e) {
        obj = value;
      }
    } else {
      obj = _storage[key];
    }
    if (obj && obj.data) {
      if (!('expire' in obj) || obj.expire > Date.now()) {
        return obj.data;
      }
      this.remove(key);
    }
    return undefined;
  },
  setItem(key, value, expire) {
    const obj = {
      data: value
    };
    if (expire > 0) {
      obj.expire = Date.now() + expire * 1000;
    }

    if (this.hasLocalStorage()) {
      localStorage.setItem(key, JSON.stringify(obj));
    } else {
      _storage[key] = obj;
    }
    return value;
  },
  remove(key) {
    if (this.hasLocalStorage()) {
      localStorage.removeItem(key);
    } else {
      delete _storage[key];
    }
  },
  clear() {
    if (this.hasLocalStorage()) {
      localStorage.clear();
    }
  }
};
